module.exports = __webpack_public_path__ + "img/hr-tree-05-f-leaves.3a5feca2.png";